// Service Cinema Studio — catalogue de modèles, défauts, estimation, pricing, parcours.
import { getRequest, postRequest } from "./api/apiService";

export const CAPABILITY_LABELS = {
  text2image: "Image",
  text2video: "Vidéo",
  image2video: "Animer une image",
  editvideo: "Modifier une vidéo",
  avatar: "Avatar",
  voiceover: "Voix off",
  ugc: "UGC / Cinéma",
  tryon: "Try-On",
};

export const fetchModels = (params = {}) => getRequest("/api/studio/models", params);
export const fetchDefaults = () => getRequest("/api/studio/defaults");
export const estimateCredits = (modelId, count) => postRequest("/api/studio/estimate", { modelId, count });
export const fetchPlans = () => getRequest("/api/pricing/plans");
export const fetchMyPlan = () => getRequest("/api/pricing/me");
export const fetchJourney = (params = {}) => getRequest("/api/onboarding/journey", params);
